import { CorpBusinessExperimentsMap } from "../types";
import { useBusinessExperimentsById } from "./useBusinessExperimentsById";

/**
 * Check to see if a variant is enabled
 *
 * @param id Experiment ID coming from Launch Darkly
 * @param variantName Variant name we're wanting to compare to
 * @returns
 */
export const useBusinessExperimentIsVariant = <
  ExperimentId extends keyof CorpBusinessExperimentsMap,
  Variant extends CorpBusinessExperimentsMap[ExperimentId]["variant"]
>(
  id: ExperimentId,
  variant: Variant
) => {
  const experiment = useBusinessExperimentsById(id);

  return experiment?.variant === variant;
};
